export default {
  // 请求接口前缀
  api: process.env.api,
  javaApi: process.env.javaApi
}